<div class="repeatable-toolbar">
    <div class="left">
        <span class="title">{{ title }}</span>
        <span class="muted"> {{ currentCount }} de {{ maxRows }} </span>
    </div>

    <div class="center">
        <span class="muted">Rellene los campos necesarios</span>
    </div>

    <div class="right">
        <button
            pButton
            type="button"
            class="p-button-success"
            [label]="addButtonLabel"
            (click)="addRowRequested.emit()"
            [disabled]="!canAddRow"
        ></button>

        @if (debug) {
            <button
                pButton
                type="button"
                class="p-button-secondary"
                icon="pi pi-info-circle"
                (click)="debugRequested.emit()"
                label="Debug"
            ></button>
        }
    </div>
</div>
